import React from 'react';
import PropTypes from 'prop-types';
 
import ReactJWPlayer from 'react-jw-player';
import { connect } from 'react-redux';

const displayName = 'ReactJWPlayerContainer';
 

class ReactJWPlayerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoTitle: '',
      playlist : [{
        // file: this.props.contentUrl,
        file:  this.props.sourceFileInfo && this.props.sourceFileInfo.sources && this.props.sourceFileInfo.sources[0].file,
        // image: 'https://link-to-my-poster.jpg',
        image: 'this.props.sourceFileInfo && this.props.sourceFileInfo.image',
        tracks: [{
          // file: 'https://link-to-subtitles.vtt',
          label: this.props.sourceFileInfo && this.props.sourceFileInfo.title,
          kind: 'captions',
          'default': true
        }],
      },
      {
        // file: 'https://link-to-my-other-video.mp4',
        // image: 'https://link-to-my-other-poster.jpg',
      }]
    };
 
    this.onAdPlay = this.onAdPlay.bind(this);
    this.onReady = this.onReady.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
 
    // each instance of <ReactJWPlayer> needs a unique id.
    // we randomly generate it here and assign to the container instance.
    // this.playerId = someFunctionToRandomlyGenerateId();
  }
  onReady(event) {
    // interact with JW Player API here
    const player = window.jwplayer('my-unique-id');
  }
  onAdPlay(event) {
    // track the ad play here
  }
  onVideoLoad(event) {
    this.setState({
      videoTitle: event.item.description // this only works with json feeds!
    });
  }
  render() {
    return (
      <div className='react-jw-player-container'>
        {/* <ReactJWPlayer
          playlist={playlist}
          licenseKey='LY2zpXRFYAdT6ui/5nnnae5On5kw7lBMiXoeOZv+Q4Y0l7Zoyour-license-key'
          onAdPlay={this.onAdPlay}
          onReady={this.onReady}
          onVideoLoad={this.onVideoLoad}
          playerId={1} // bring in the randomly generated playerId
          playerScript='https://link-to-your-jw-player-script.js'
        /> */}
          <ReactJWPlayer
            playerId='LeDK9Bar'
            playerScript='https://cdn.jwplayer.com/libraries/LeDK9Bar.js'
            playlist={this.state.playlist}
            onReady={this.onReady}
            isAutoPlay={true}

        />
      </div>
    );
  } 
}
 
const mapStatesToProps = state => ({
  sourceFileInfo: state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.response && state.JwPlayerSourceInfo.response.playlist[0]
})

export default connect(mapStatesToProps, {})(ReactJWPlayerContainer);